var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 22.458q-1.042 0-1.75-.729T6.667 20q0-1 .729-1.729.729-.729 1.729-.729t1.708.729q.709.729.709 1.729t-.709 1.729q-.708.729-1.708.729Zm10.875 0q-1 0-1.729-.729Q17.542 21 17.542 20t.729-1.729Q19 17.542 20 17.542t1.729.729q.729.729.729 1.729t-.729 1.729q-.729.729-1.729.729Zm10.875 0q-1 0-1.708-.729Q28.458 21 28.458 20t.709-1.729q.708-.729 1.708-.729 1.042 0 1.75.729T33.333 20q0 1-.729 1.729-.729.729-1.729.729Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/ThreeDotsIcon.a1781be21c25172667643af65f5fabcd.svg";
export { ForwardRef as ReactComponent };